/**
 * The only module that touches Web Storage.
 *
 * Everything is namespaced and every access is guarded: Safari in Private mode
 * throws on `localStorage` access rather than returning null, and an unguarded
 * read there takes the whole shell down on first paint.
 *
 * Per the coding guidelines, nothing sensitive is stored here — UI preferences,
 * the garden's plant ids, and the email-link flow's pending address (which
 * Firebase's own flow requires a copy of on this device).
 */

const NAMESPACE = 'plant.habb.me';

function getStorage() {
    try {
        return typeof window !== 'undefined' ? window.localStorage : null;
    } catch (error) {
        return null;
    }
}

function namespacedKey(key) {
    return `${NAMESPACE}:${key}`;
}

export function readSetting(key) {
    const storage = getStorage();

    if (!storage) {
        return null;
    }

    try {
        return storage.getItem(namespacedKey(key));
    } catch (error) {
        return null;
    }
}

export function writeSetting(key, value) {
    const storage = getStorage();

    if (!storage) {
        return false;
    }

    try {
        storage.setItem(namespacedKey(key), value);
        return true;
    } catch (error) {
        // Quota exhausted or storage disabled — a lost preference is recoverable,
        // a thrown error during render is not.
        return false;
    }
}

export function removeSetting(key) {
    const storage = getStorage();

    if (!storage) {
        return false;
    }

    try {
        storage.removeItem(namespacedKey(key));
        return true;
    } catch (error) {
        return false;
    }
}
